import Header from './components/Header';
import Hero from './components/Hero';
import TagWall from './components/TagWall';
import HotRank from './components/HotRank';
import Feed from './components/Feed';
import Track from './components/Track';
import Sides from './components/Sides';
import Faq from './components/Faq';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-900">
      <Header />
      <main>
        <Hero />
        <TagWall />
        <HotRank />
        <Feed />
        <Track />
        <Sides />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}